import React from "react";
import styles from "./Row.module.sass";
import { useUser } from "../../../../context";
import ticket from "../../../../i11/TicketingProvider";

const Row = ({ data, open, exp = false, fullData = {} }) => {
	const { locale } = useUser();
	const date = new Date(data.updatedAt);
	return (
		<>
			<div className={styles.row}>
				<div className={styles.col} />
				<div className={styles.col}>
					<div className={styles.item} onClick={() => open()}>
						<div className={styles.details}>
							<div className={styles.user}>{data}</div>
						</div>
					</div>
				</div>
				<div className={styles.col}>{data}</div>
				<div className={styles.col}></div>
				<div className={styles.col}></div>

				<button onClick={() => open()} className="button-stroke button-small">
					{ticket[locale].confirm}
				</button>
			</div>
		</>
	);
};

export default Row;
